<template>
  <div class="checkbox-filter">
    <p class="filter-title" v-html="tax.label"></p>

    <div class="form-check form-check-all">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        ref="all"
        :id="tax.taxonomy + '_all'"
        v-model="value"
      />
      <label class="form-check-label" :for="tax.taxonomy + '_all'">{{
        $store.state.i18n.all
      }}</label>
    </div>

    <CheckboxToggle
      v-for="item in tax.terms"
      :key="item.term_id"
      :checkbox="item"
      :tax_key="tax_key"
    />
  </div>
</template>

<script>
import CheckboxToggle from "./CheckboxToggle";

export default {
  name: "CheckboxFilter",
  components: {
    CheckboxToggle,
  },
  props: {
    tax: Object,
    tax_key: Number,
  },
  computed: {
    value: {
      get() {
        return this.$store.state.taxonomies[this.tax_key].active.length == 0;
      },
      set(val) {
        this.$store.commit("REMOVE_ALL_TAXONOMY", this.tax_key);
        this.$refs.all.checked = true;
        this.$store.dispatch("newRequest");
      },
    },
  },
};
</script>
